export default "__VITE_ASSET__BECUcGLC__"